// Remove the alternate card image on tablet and smaller viewports.
const removeAltImages = (root = document) => {
  if (window.innerWidth > 768) return;
  root
    .querySelectorAll(".card-product-alt-image")
    .forEach((altImage) => altImage.remove());
};

removeAltImages();

document.addEventListener("DOMContentLoaded", () => {
  const loadMoreBtn = document.getElementById("load-more-btn");
  if (!loadMoreBtn) return;

  const wrapper = loadMoreBtn.closest(".load-more");
  const label = wrapper?.querySelector("[data-load-more-label]");
  const hiddenLabel = loadMoreBtn.querySelector(".visually-hidden");

  loadMoreBtn.addEventListener("click", async () => {
    const nextUrl = loadMoreBtn.getAttribute("data-next-url");
    if (!nextUrl) return;

    loadMoreBtn.disabled = true;

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
      const productGrid = document.getElementById("product-grid");
      // Only take product items; the promo module is already on the page.
      const newProducts = [...html.querySelectorAll("#product-grid > li")].filter(
        (item) => item.querySelector("product-card"),
      );

      newProducts.forEach((product) => {
        removeAltImages(product);
        productGrid.appendChild(product);
      });

      const newNextBtn = html.querySelector("#load-more-btn");

      if (newNextBtn) {
        loadMoreBtn.setAttribute(
          "data-next-url",
          newNextBtn.getAttribute("data-next-url"),
        );
        loadMoreBtn.disabled = false;
      } else {
        // Last page: move focus into the new products before removing the button.
        newProducts[0]?.querySelector("a, button")?.focus();
        (wrapper || loadMoreBtn).remove();
      }
    } catch (error) {
      console.error("Error fetching more products:", error);
      loadMoreBtn.disabled = false;
      const retryText = loadMoreBtn.dataset.retryText;
      if (retryText) {
        if (label) label.textContent = retryText;
        if (hiddenLabel) hiddenLabel.textContent = retryText;
      }
    }
  });
});
